import {
  Agency,
  LoanData,
  PropertyData,
  Party,
  Parties,
  OrderStage,
  ActionItem,
  ActivityEvent,
  Message,
} from '../types'

export const mockAgencies: Agency[] = [
  {
    id: 'ag-1',
    name: 'Apex Title & Settlement',
    address: '100 Main St, Suite 400',
    city: 'Austin',
    state: 'TX',
    zip: '78701',
    phone: '(512) 555-0198',
    allowsPreOpen: true,
    titleSearchOnly: true,
  },
  {
    id: 'ag-2',
    name: 'Beacon National Title',
    address: '500 Florida Ave',
    city: 'Miami',
    state: 'FL',
    zip: '33101',
    phone: '(305) 555-8821',
    allowsPreOpen: false,
    titleSearchOnly: true,
  },
  {
    id: 'ag-3',
    name: 'Crestview Settlement Services',
    address: '1200 Broadway',
    city: 'New York',
    state: 'NY',
    zip: '10001',
    phone: '(212) 555-3344',
    allowsPreOpen: true,
    titleSearchOnly: false,
  },
  {
    id: 'ag-4',
    name: 'Pioneer Title Agency',
    address: '8800 Colorado Blvd',
    city: 'Denver',
    state: 'CO',
    zip: '80202',
    phone: '(303) 555-9912',
    allowsPreOpen: true,
    titleSearchOnly: true,
  },
  {
    id: 'ag-5',
    name: 'Golden State Escrow',
    address: '400 Market St',
    city: 'San Francisco',
    state: 'CA',
    zip: '94104',
    phone: '(415) 555-7734',
    allowsPreOpen: false,
    titleSearchOnly: false,
  },
  {
    id: 'ag-6',
    name: 'Midwest Title Partners',
    address: '200 N Michigan Ave',
    city: 'Chicago',
    state: 'IL',
    zip: '60601',
    phone: '(312) 555-4422',
    allowsPreOpen: true,
    titleSearchOnly: true,
  },
]

export const mockLoanData: LoanData = {
  amount: 485000,
  number: '2024-08-1547',
  type: 'CONVENTIONAL_INSURED',
  purchasePrice: 525000,
  purpose: 'Purchase',
  externalReferenceNumber: '',
  isPreopen: false,
}

export const mockPropertyData: PropertyData = {
  address1: '742 Evergreen Terrace',
  city: 'Springfield',
  state: 'IL',
  zip: '62704',
  county: 'Sangamon',
}

export const mockParties: Parties = {
  borrowers: [
    {
      _id: 'p-1',
      entity_type: 'INDIVIDUAL',
      first_name: 'John',
      last_name: 'Smith',
      email: 'john.smith@example.com',
      cell_phone: '(555) 123-4567',
      on_title: true,
      marital_status: 'MARRIED',
      ssn: 'XXX-XX-1234',
      spouse_first_name: 'Jane',
      spouse_last_name: 'Smith',
      spouse_email: 'jane.smith@example.com',
      spouse_cell_phone: '(555) 123-4568',
      spouse_on_title: true,
      spouse_ssn: 'XXX-XX-5678',
    },
  ],
  sellers: [
    {
      _id: 'p-3',
      entity_type: 'INDIVIDUAL',
      first_name: 'Robert',
      last_name: 'Johnson',
      email: 'robert.j@example.com',
      cell_phone: '(555) 987-6543',
      on_title: true,
    },
    {
      _id: 'p-4',
      entity_type: 'ORGANIZATION',
      first_name: 'Maria',
      last_name: 'Johnson',
      email: 'maria.j@example.com',
      cell_phone: '(555) 987-6544',
      organization_name: 'Johnson Properties LLC',
      organization_type: 'LLC',
      on_title: true,
    },
  ],
  lender_contacts: [],
  listing_agents: [],
  selling_agents: [],
}

export const mockOrderStages: OrderStage[] = [
  {
    id: 's-1',
    name: 'Order Accepted',
    status: 'completed',
    date: 'Oct 12, 9:00 AM',
  },
  {
    id: 's-2',
    name: 'Title Search Started',
    status: 'completed',
    date: 'Oct 12, 11:30 AM',
  },
  {
    id: 's-3',
    name: 'Title Commitment Available',
    status: 'completed',
    date: 'Oct 14, 2:15 PM',
  },
  {
    id: 's-4',
    name: 'Title Review Complete',
    status: 'completed',
    date: 'Oct 15, 10:00 AM',
  },
  {
    id: 's-5',
    name: 'Title Clear',
    status: 'completed',
    date: 'Oct 16, 4:45 PM',
  },
  { id: 's-6', name: 'Closing Prep', status: 'current' },
  { id: 's-7', name: 'Funds Disbursed', status: 'upcoming' },
  { id: 's-8', name: 'Title Insurance Issued', status: 'upcoming' },
]

export const mockActionItems: ActionItem[] = [
  {
    id: 'a-1',
    title: 'Confirm Loan Info',
    description: 'Please verify the final loan amount matches the updated CD.',
    urgency: 'high',
    createdAt: '2 hours ago',
  },
  {
    id: 'a-2',
    title: 'Provide HOA Info',
    description:
      'We need the contact information for the Evergreen Terrace HOA.',
    urgency: 'high',
    createdAt: '4 hours ago',
  },
  {
    id: 'a-3',
    title: 'Upload Survey',
    description: 'Upload the property survey document if available.',
    urgency: 'medium',
    createdAt: '1 day ago',
  },
]

export const mockActivityEvents: ActivityEvent[] = [
  {
    id: 'ev-1',
    type: 'status_update',
    title: 'Stage Updated: Closing Prep',
    description: 'The order has moved to the Closing Prep stage.',
    timestamp: '2 hours ago',
    user: 'System',
  },
  {
    id: 'ev-2',
    type: 'document_shared',
    title: 'Title Commitment Uploaded',
    description: 'Commitment_742_Evergreen.pdf was added to the file.',
    timestamp: 'Oct 14, 2:15 PM',
    user: 'Sarah Jenkins (Title)',
  },
  {
    id: 'ev-3',
    type: 'message',
    title: 'New Message',
    description:
      'Sarah Jenkins: "The title search came back clean, we are moving to commitment."',
    timestamp: 'Oct 14, 1:00 PM',
    user: 'Sarah Jenkins',
  },
  {
    id: 'ev-4',
    type: 'field_update',
    title: 'Loan Amount Updated',
    description: 'Loan amount changed from $480,000 to $485,000.',
    timestamp: 'Oct 13, 11:45 AM',
    user: 'Mike Processor',
  },
  {
    id: 'ev-5',
    type: 'status_update',
    title: 'Stage Updated: Title Search Started',
    description: 'The title search process has begun.',
    timestamp: 'Oct 12, 11:30 AM',
    user: 'System',
  },
  {
    id: 'ev-6',
    type: 'order_placed',
    title: 'Order Placed',
    description: 'Title order was submitted to Midwest Title Partners.',
    timestamp: 'Oct 12, 9:00 AM',
    user: 'Mike Processor',
  },
]

export const mockMessages: Message[] = [
  {
    id: 'm-1',
    sender: 'Mike Processor',
    initials: 'MP',
    content:
      'Hi Sarah, just submitted this order. Let me know if you need anything else from our end to get started.',
    timestamp: 'Oct 12, 9:05 AM',
  },
  {
    id: 'm-2',
    sender: 'Sarah Jenkins',
    initials: 'SJ',
    content:
      'Received! We are starting the title search now. I will let you know if any flags come up.',
    timestamp: 'Oct 12, 9:15 AM',
  },
  {
    id: 'm-3',
    sender: 'Sarah Jenkins',
    initials: 'SJ',
    content:
      'The title search came back clean, we are moving to commitment. I just uploaded the preliminary docs.',
    timestamp: 'Oct 14, 1:00 PM',
    attachments: ['Commitment_742_Evergreen.pdf'],
  },
  {
    id: 'm-4',
    sender: 'Mike Processor',
    initials: 'MP',
    content: 'Thanks Sarah. I am reviewing the commitment now. Looks good.',
    timestamp: 'Oct 14, 2:30 PM',
  },
  {
    id: 'm-5',
    sender: 'Sarah Jenkins',
    initials: 'SJ',
    content:
      'Great. We are prepping for closing. Can you please provide the HOA contact info when you have a moment?',
    timestamp: '4 hours ago',
  },
]
